/*
 * Copyright © 2017-Present, The Freshwater Trust, all rights reserved.
 */

import {BaseFieldEditor} from "./BaseFieldEditor";
import autobind from "autobind-decorator";
import {FormControl} from "react-bootstrap";
import React from "react";

export class ProgramRelativeYearEditorField extends BaseFieldEditor {
	@autobind
	_render() {
		const MAX_YEAR = 50;

		return <FormControl
			as="select"
			placeholder="Select A Year"
			value={this.props.Value != null ? this.props.Value : ""}
			onChange={(x) => this.props.OnUpdate(x.target.value)}
		>
			{
				(new Array(MAX_YEAR)).fill().map((_, x) => <option value={x + 1} key={x + 1}>{x + 1}</option>)
			}
		</FormControl>;
	}
}